document.addEventListener("DOMContentLoaded", (event) => {
	const testimonialSections = document.querySelectorAll(" .testimonials-slider ");

	if (testimonialSections && testimonialSections.length > 0) {
		testimonialSections.forEach((section) => {
			const wrapper = section.querySelector(".wp-block-kadence-query-card ");
			const prevBtn = section.querySelector(".kb-show-more-buttons .kb-button:first-of-type");
			const nextBtn = section.querySelector(".kb-show-more-buttons .kb-button:last-of-type");
			const testimonials = section.querySelectorAll(".kb-query-item");

			const numOfTestimonials = testimonials.length - 1;
			let currSlide = 0;

			// Set the height for the testimonials and recalculate based on screen width
			const resizeObserver = new ResizeObserver((entries) => {
				for (let entry of entries) {
					if (entry.target === wrapper) {
						const maxTestimonialHeight = Math.ceil(Math.max(...Array.from(testimonials).map((t) => t.querySelector(".kt-inside-inner-col").getBoundingClientRect().height)));
						if (maxTestimonialHeight) {
							wrapper.style.minHeight = `${maxTestimonialHeight}px`;
						}
					}
				}
			});
			resizeObserver.observe(wrapper);

			setTimeout(() => (wrapper.style.opacity = `1`), 500);

			if (testimonials.length === 1) {
				prevBtn.classList.add("hide");
				nextBtn.classList.add("hide");
			} else {
				testimonials.forEach((slide, index) => {
					slide.style.transform = `translateX(${100 * index}%)`;
				});

				getSlide(testimonials, currSlide);

				nextBtn.addEventListener("click", (e) => {
					e.preventDefault();

					currSlide++;

					if (currSlide > numOfTestimonials) currSlide = 0;
					getSlide(testimonials, currSlide);
				});

				prevBtn.addEventListener("click", (e) => {
					e.preventDefault();

					currSlide--;
					if (currSlide < 0) currSlide = numOfTestimonials;
					getSlide(testimonials, currSlide);
				});
			}
		});
	}
});

function getSlide(slides, currSlide) {
	slides.forEach((slide, index) => {
		slide.style.transform = `translateX(${100 * (index - currSlide)}%)`;
	});
}
